export const CATALOG_CLOSE = 'CATALOG:CATALOG_CLOSE';
export const CATALOG_RECORD_LIST_LOADED = 'CATALOG:RECORD_LIST_LOADED';
export const CATALOG_RECORD_LIST_LOAD_ERROR = 'CATALOG:RECORD_LIST_LOAD_ERROR';
export const CATALOG_CHANGE_SELECTED_SERVICE = 'CATALOG:CHANGE_SELECTED_SERVICE';
export const CATALOG_ADD_CATALOG_SERVICE =  'CATALOG:ADD_CATALOG_SERVICE';
export const CATALOG_DELETE_CATALOG_SERVICE =  'CATALOG:DELETE_CATALOG_SERVICE';
export const CATALOG_CHANGE_CATALOG_MODE = 'CATALOG:CHANGE_CATALOG_MODE';
export const CATALOG_INITED = 'CATALOG:INIT';
export const CATALOG_SET_LOADING = 'CATALOG:SET_LOADING';
export const CATALOG_SAVING_SERVICE = 'CATALOG:SAVING_SERVICE';
export const CATALOG_CHANGE_TEXT = 'CATALOG:CHANGE_TEXT';
export const CATALOG_TEXT_SEARCH = 'CATALOG:TEXT_SEARCH';
export const CATALOG_ADD_LAYER_FROM_CATALOGS = 'CATALOG:ADD_LAYER_FROM_CATALOGS';
